"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateForm = void 0;

var _immutable = require("immutable");

var _getFieldValues = require("../helpers/getFieldValues");

var validateForm = function validateForm(validateFunctions, fieldData) {
  if (!validateFunctions) return {};
  var values = (0, _getFieldValues.getFieldValues)(fieldData);
  var results = (0, _immutable.Map)();
  var validators = validateFunctions;

  if (!Array.isArray(validateFunctions)) {
    validators = [validateFunctions];
  }

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = validators[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var v = _step.value;
      results = results.mergeDeep(v(values));
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return results.toJS();
};

exports.validateForm = validateForm;